export const SET_CURRENT_STREAM_DATA = 'SET_CURRENT_STREAM_DATA';

export const SET_ADD_RUNNING = 'SET_ADD_RUNNING';

export const SET_TWITCH_CHAT_SETTINGS = 'SET_TWITCH_CHAT_SETTINGS';
export const UPDATE_TWITCH_CHAT_SETTINGS = 'UPDATE_TWITCH_CHAT_SETTINGS';


export const SET_TWITCH_LOG = 'SET_TWITCH_LOG';

export const SET_TWITCH_MODS = 'SET_TWITCH_MODS';